import React from 'react';
import _ from 'lodash';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import Modal from '~/components/modal';
import { Select } from '~/components/form';
import { typesList } from '~/views/emails-template/form';

const Container = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

function PressMailModal({ data, title, areas, isOpen, loading, closeModal, handleOnSubmit }) {

  let list = _.map(data.templates, (r) => {
    let label = r.type;
    return { value: `${r.id}`, label: _.get(_.find(typesList, { value: label }), 'label') || label }
  });
  list.unshift({ value: '', label: 'Escolha uma opção' })
  
  return (
    <Formik
      enableReinitialize={true}
      initialValues={data}
      >
      {({ values, isValid, touched, errors, handleReset }) => (
        <Modal
          width="560px"
          height="180px"
          hideClose={true}
          open={isOpen}
          hide={closeModal}
          title={title}
          actions={[
            {
              label: 'Cancelar',
              action: () => { handleReset() ; closeModal() },
              disabled: loading
            },
            {
              label: 'Enviar',
              action: () => { handleOnSubmit(values); handleReset() },
              primary: true,
              disabled: loading || !values.id
            }
          ]}
          >
          <Container>
            <Select
              name="id"
              label="Template"
              options={{ values: list }}
            />
          </Container>
        </Modal>
      )}
    </Formik>
  );
};

export default PressMailModal;
